import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

export default{
	namespaced: true,
	state:{
		conversaciones:[],
		conversacionesM:[],
		conversacionesG:[],
		conversacionesC:[],
		conversacionesF:[],
		conversacionesFast:[],
		conversacionesAgente:[],
		conversacionesCRM:[],
		conversacionesCRMFast:[],
		conversacionesOnline:[],
		conversacionesUnificadas: [],
		conversacionesExces: [],
		conversacionesUnificadasFast: [],
	},

	mutations:{
		CONVERSACIONES(state, value){
			state.conversaciones = Array.isArray(value) ? value : []
		},

		CONVERSACIONESM(state, value){
			state.conversacionesM = Array.isArray(value) ? value : []
		},

		CONVERSACIONESG(state, value){
			state.conversacionesG = Array.isArray(value) ? value : []
		},

		CONVERSACIONESC(state, value){
			state.conversacionesC = Array.isArray(value) ? value : []
		},

		CONVERSACIONESFAST(state, value){
			state.conversacionesFast = Array.isArray(value) ? value : []
		},

		CONVERSACIONESAGENTE(state, value){
			state.conversacionesAgente = Array.isArray(value) ? value : []
		},

		CONVERSACIONESCRM( state, value){
			state.conversacionesCRM = Array.isArray(value) ? value : []
		},

		CONVERSACIONESCRMFAST( state, value){
			state.conversacionesCRMFast = Array.isArray(value) ? value : []
		},

		CONVERSACIONESONLINE( state, value){
			state.conversacionesOnline = Array.isArray(value) ? value : []
		},

		CONVERSACIONESUNIF( state, value){
			state.conversacionesUnificadas = Array.isArray(value) ? value : []
		},

		CONVERSACIONESEXCES( state, value ){
			state.conversacionesExces = Array.isArray(value) ? value : []
		},

		CONVERSACIONESUNIFFAST( state, value){
			state.conversacionesUnificadasFast = Array.isArray(value) ? value : []
		},
	},

	actions:{

		guardarConversaciones({ commit, dispatch}, conversaciones){
			commit('CONVERSACIONES',conversaciones)
		},

		guardarConversacionesM({ commit, dispatch}, conversaciones){
			commit('CONVERSACIONESM',conversaciones)
		},

		guardarConversacionesG({ commit, dispatch}, conversaciones){
			commit('CONVERSACIONESG',conversaciones)
		},

		guardarConversacionesC({ commit, dispatch}, conversaciones){
			commit('CONVERSACIONESC',conversaciones)
		},

		guardarConversacionesFast({ commit, dispatch}, conversaciones){
			commit('CONVERSACIONESFAST',conversaciones)
		},

		guardarConversacionesAgente({ commit, dispatch}, conversaciones){
			commit('CONVERSACIONESAGENTE',conversaciones)
		},

		guardarConversacionesCRM({ commit, dispatch}, conversaciones){
			commit('CONVERSACIONESCRM',conversaciones)
		},

		guardarConversacionesCRMFast({ commit, dispatch}, conversaciones){
			commit('CONVERSACIONESCRMFAST',conversaciones)
		},

		guardarConversacionesOnline({ commit, dispatch}, conversaciones){
			commit('CONVERSACIONESONLINE',conversaciones)
		},

		guardarConversacionesUnif({ commit, dispatch}, conversaciones){
			commit('CONVERSACIONESUNIF',conversaciones)
		},

		guardarConversacionesExces({ commit, dispatch}, conversaciones){
			commit('CONVERSACIONESEXCES',conversaciones)
		},

		guardarConversacionesUnifFast({ commit, dispatch}, conversaciones){
			commit('CONVERSACIONESUNIFFAST',conversaciones)
		},
  },

	getters:{
		getConversaciones(state){
		  return Array.isArray(state.conversaciones) ? state.conversaciones : []
		},

		getConversacionesM(state){
		  return Array.isArray(state.conversacionesM) ? state.conversacionesM : []
		},

		getConversacionesG(state){
		  return Array.isArray(state.conversacionesG) ? state.conversacionesG : []
		},

		getConversacionesC(state){
		  return Array.isArray(state.conversacionesC) ? state.conversacionesC : []
		},

		getConversacionesFast(state){
		  return Array.isArray(state.conversacionesFast) ? state.conversacionesFast : []
		},

		getConversacionesAgente(state){
		  return Array.isArray(state.conversacionesAgente) ? state.conversacionesAgente : []
		},

		getConversacionesCRM(state){
		  return Array.isArray(state.conversacionesCRM) ? state.conversacionesCRM : []
		},

		getConversacionesCRMFast(state){
		  return Array.isArray(state.conversacionesCRMFast) ? state.conversacionesCRMFast : []
		},

		getConversacionesO(state){
		  return Array.isArray(state.conversacionesOnline) ? state.conversacionesOnline : []
		},

		getConversacionesUnif(state){
		  return Array.isArray(state.conversacionesUnificadas) ? state.conversacionesUnificadas : []
		},

		getConversacionesExces(state){
		  return Array.isArray(state.conversacionesExces) ? state.conversacionesExces : []
		},

		getConversacionesUnifFast(state){
		  return Array.isArray(state.conversacionesUnificadasFast) ? state.conversacionesUnificadasFast : []
		},
	}
}